const CategoryQueryKey = {
  CATEGORY: 'CATEGORY',
  CATEGORY_DEPTH2: 'CATEGORY_DEPTH2',
  CATEGORY_DEPTH3: 'CATEGORY_DEPTH3',
};

export default CategoryQueryKey;
